/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import r,{createContext as e,useContext as o}from"react";let t=e(!1);function n(){return o(t)}function a(e){return r.createElement(t.Provider,{value:e.force},e.children)}export{a as ForcePortalRoot,n as usePortalRoot};
//# sourceMappingURL=portal-force-root.js.map
